<script lang="ts">
  import Lazy from 'svelte-lazy';
  import { PUBLIC_STRAPI_MEDIA } from '$env/static/public';
  import { is_set_array, is_set_object, datetimeToDate } from '$lib/js/helpers';
  import { page } from '$app/stores'
  import { t } from 'svelte-i18n-lingui';
  import type { HeroSection, Attributes } from "$lib/js/strapi/types";
  import '$lib/css/components/u-text.scss'
	import { getContextScope } from '$lib/js/helpers/i18n'

  export let component: HeroSection
  export let type: '' | 'sm' = ''

	const scope = getContextScope()

  let image: Attributes = {}
  let lazyHeight = 300

  $: if(type === 'sm') {
    lazyHeight = 200
  }

  if(is_set_object(component.bg_img)) {
    image = component.bg_img;
  }

  /* Check if it is a post */
  let categories = (is_set_object($page.data.page_data) && is_set_object($page.data.page_data.blog_categories)) ? $page.data.page_data.blog_categories : []
</script>


<div class="u-header {type}">
  {#if image}
    <Lazy height={lazyHeight}>
      <img src="{PUBLIC_STRAPI_MEDIA}{image.url}" title="" alt="">
    </Lazy>
  {/if}

  {#if component.page_title}
    <div class="u-header__inner">
      <div class="container">
        <h1>{component.page_title}</h1>

        {#if is_set_array(categories)}
          <a href="/{scope}/blog/c/{categories[0].name.toLowerCase()}"
             class="u-header__cat u-btn">{categories[0].name}</a>
        {/if}
      </div>
    </div>
  {/if}
</div>

{#if is_set_array(categories)}
  <div class="container u-header__date">
    <p>{$t`Published at ${datetimeToDate($page.data.page_data.publishedAt, {scope: scope})}`}</p>
  </div>
{/if}


<style lang="scss">
  .u-header {
    position: relative;
    height: 300px;

    &.sm {
      overflow: hidden;
      height: 200px;
    }

    &__inner {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 50%);
    }

    &__cat {
      position: absolute;
      bottom: -12px;
      padding: 3px 10px;
      font-weight: 400;
      text-transform: uppercase;

      &:hover {
        background: var(--main);
        color: white;

        @media (min-width: 769px) {
          transform: scale(1.1);
        }
      }
    }

    &__date {
      margin-top: 35px;

      p {
        color: var(--grey--b);
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    h1 {
      max-width: 320px;
      font-weight: 700;
      color: #fff;
      margin-top: 50px;

      @media (min-width: 769px) {
        max-width: 520px;
      }
    }
  }
</style>
